const state = {
  allPanels: [],
  myPanels: []
};

const mutations = {
  SET_PANELS: (state, data) => {
    state.allPanels = data;
  },
  SET_MY_PANELS: (state, data) => {
    state.myPanels = data;
  }
};

const actions = {
  setPanels({ commit }, data) {
    commit("SET_PANELS", data);
  },
  setMyPanels({ commit }, data) {
    commit("SET_MY_PANELS", data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
